import { useNavigate, useLocation } from "react-router-dom";
import {
  FunSvg,
  GroupSvg,
  HomeSvg,
  PlayerSvg,
  ProfileSvg,
  ProgramSvg,
  SkillSvg,
  TrackerSvg,
  TrainingSvg,
} from "../../svgFile";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("accessToken");

  const user = JSON.parse(localStorage.getItem("userData"));

  // ----- Role Based Footer Items -----
  const playerFooterItems = [
    { path: "/training-page", label: "Training", icon: <TrainingSvg /> },
    { path: "/skills", label: "Skills", icon: <SkillSvg /> },
    { path: "/", label: "Home", icon: <HomeSvg /> },
    { path: "/fun", label: "Fun", icon: <FunSvg /> },
    { path: "/tracker", label: "Tracker", icon: <TrackerSvg /> },
  ];

  const coachFooterItems = [
    { path: "/teams", label: "Teams", icon: <GroupSvg/> },
    { path: "/players", label: "Players", icon: <PlayerSvg /> },
    { path: "/", label: "Home", icon: <HomeSvg /> },
    { path: "/program", label: "Program", icon: <ProgramSvg /> },
    { path: "/myprofile", label: "Profile", icon: <ProfileSvg /> },
  ];

  // Select items based on role
  const footerItems = !token
    ? playerFooterItems
    : user?.role === "Player"
    ? playerFooterItems
    : coachFooterItems;

  const handleNavigation = (path) => {
     if (path === "/") {
    navigate(path);
    return;
  }
    // Protect some routes
    if (!token) {
      navigate("/signin");
    } else {
      navigate(path);
    }
  };

  return (
    <footer>
      <div className="footer-section d-flex align-items-center justify-content-between gap-2 common-bg">
        {footerItems.map((item, index) => {
          const isActive =
            item.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.path);

          return (
            <button
              key={index}
              onClick={() => handleNavigation(item.path)}
              className={`footer-item text-center btn p-0 border-0 bg-transparent ${
                isActive ? "active" : ""
              }`}
            >
              {item.icon}
              <span className="d-block mt-1">{item.label}</span>
            </button>
          );
        })}
      </div>
    </footer>
  );
};

export default Footer;
